import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslationDatabaseService } from "../../../../auth/service/translation-database.service";
import { Router } from "@angular/router";
import wolrdLanguages from "../../../../auth/models/languages";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-translate-db-list",
  templateUrl: "./translate-db-list.component.html",
  styleUrls: ["./translate-db-list.component.scss"],
})
export class TranslateDbListComponent implements OnInit {
  public contentHeader: IContentHeader;
  public fieldsList: any = [];
  public searchKey: string = "";
  public filteredFields: any = [];
  public newField: string = "";
  public newLabel: string = "";
  public newLanguage: string = "";
  public currentField: any;
  public languages_list: string[] = wolrdLanguages;
  public showErrors: boolean = false;

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _modalService: NgbModal,
    public _translationService: TranslationDatabaseService,
    private _routerService: Router,
  ) {}

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_field_database_list")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }
    this.contentHeader = {
      headerTitle: "MENU.FIELDS_DB",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.FIELDS_DB",
            isLink: false,
          },
        ],
      },
    };
    await this.loadFieldsList();
    await this.searchField();
  }

  async loadFieldsList() {
    this.fieldsList = await this._translationService.getList();
    this.fieldsList.sort((a, b) => a.field.localeCompare(b.field));
  }

  async searchField() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filteredFields: any = this.fieldsList;
    if (key.length > 0) {
      filteredFields = filteredFields.filter((item: any) => {
        return item.field.toLowerCase().includes(key) || item.label.toLowerCase().includes(key) || item.language.toLowerCase().includes(key);
      });
    }
    this.filteredFields = filteredFields;
  }

  public modalOpen(modalBasic, currentField) {
    this.newLanguage = "";
    this.newField = "";
    this.newLabel = "";
    this._modalService.open(modalBasic, {
      size: "md",
      centered: true,
    });
    this.currentField = JSON.parse(JSON.stringify(currentField));
    this.showErrors = false;
  }

  async add() {
    if (!this._authenticationService.hasCapability("add_fieldDatabase")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!!this.newLanguage) {
      this.newLanguage = this.newLanguage.trim();
    }

    if (!!this.newField) {
      this.newField = this.newField.trim();
    }

    if (!!this.newLabel) {
      this.newLabel = this.newLabel.trim();
    }

    if (!this.newField || this.newField.length < 1 || !this.newLabel || this.newLabel.length < 1 || !this.newLanguage || this.newLanguage.length < 1) {
      this.showErrors = true;
      return false;
    }

    let data = {
      field: this.newField,
      label: this.newLabel,
      language: this.newLanguage,
    };
    await this._utilService.showLoading();
    await this._translationService
      .createField(data)
      .then(async () => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        await this.loadFieldsList();
        await this.searchField();
        this._modalService.dismissAll();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_FIELD" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPLOAD_FIELD" });
      });
  }

  async edit() {
    if (!this._authenticationService.hasCapability("edit_fieldDatabase")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.currentField.language) {
      this.currentField.language = this.currentField.language.trim();
    }

    if (!!this.currentField.field) {
      this.currentField.field = this.currentField.field.trim();
    }

    if (!!this.currentField.label) {
      this.currentField.label = this.currentField.label.trim();
    }

    if (!this.currentField.field || this.currentField.field.length < 1 || !this.currentField.label || this.currentField.label.length < 1 || !this.currentField.language || this.currentField.language.length < 1) {
      this.showErrors = true;
      return false;
    }

    let data = {
      field: this.currentField.field,
      label: this.currentField.label,
      language: this.currentField.language,
    };
    await this._utilService.showLoading();
    await this._translationService
      .updateField(this.currentField.id, data)
      .then(async () => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_FIELD" });
        await this.loadFieldsList();
        await this.searchField();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDIT_FIELD" });
      });
  }

  async delete(field: any) {
    if (!this._authenticationService.hasCapability("delete_fieldDatabase")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += ` ${field.field}`;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._translationService
            .deleteField(field.id)
            .then(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_FIELD" });
              await this.loadFieldsList();
              await this.searchField();
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_DELETE_CUSTOMER" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_FIELD" });
      });
  }
}
